import React from 'react';

import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { TopNavEnd, TopNavMiddle, TopNavStart } from '@atlaskit/navigation-system/layout/top-nav';
import { AppLogo, AppSwitcher } from '@atlaskit/navigation-system/top-nav-items';
import { CreateButton } from '@atlaskit/navigation-system/top-nav-items/create-button';
import { Help } from '@atlaskit/navigation-system/top-nav-items/help';
import { Profile } from '@atlaskit/navigation-system/top-nav-items/profile';
import { Settings } from '@atlaskit/navigation-system/top-nav-items/settings';

import { MockSearch } from '../../utils/mock-search';

export const MockContent = (): React.JSX.Element => {
	return (
		<>
			<TopNavStart sideNavToggleButton={null}>
				<AppSwitcher label="App switcher" />
				<AppLogo
					href="https://www.atlassian.design"
					icon={ConfluenceIcon}
					name="Confluence"
					label="Home page"
				/>
			</TopNavStart>
			<TopNavMiddle>
				<MockSearch />
				<CreateButton>Create</CreateButton>
			</TopNavMiddle>
			<TopNavEnd>
				<Help label="Help" />
				<Settings label="Settings" />
				<Profile label="Your profile" />
			</TopNavEnd>
		</>
	);
};
